var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.875V32.0625",
    stroke: "#EA7000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3008 2.00001H19.1992C18.899 1.99896 18.6014 2.05714 18.3236 2.17122C18.0459 2.28531 17.7933 2.45305 17.5805 2.66486L2.66486 17.5805C2.45305 17.7933 2.28531 18.0459 2.17122 18.3236C2.05714 18.6014 1.99896 18.899 2.00001 19.1992V40.3008C1.99896 40.6011 2.05714 40.8986 2.17122 41.1764C2.28531 41.4541 2.45305 41.7067 2.66486 41.9195L17.5805 56.8352C17.7933 57.047 18.0459 57.2147 18.3236 57.3288C18.6014 57.4429 18.899 57.5011 19.1992 57.5H40.3008C40.6011 57.5011 40.8986 57.4429 41.1764 57.3288C41.4541 57.2147 41.7067 57.047 41.9195 56.8352L56.8352 41.9195C57.047 41.7067 57.2147 41.4541 57.3288 41.1764C57.4429 40.8986 57.5011 40.6011 57.5 40.3008V19.1992C57.5011 18.899 57.4429 18.6014 57.3288 18.3236C57.2147 18.0459 57.047 17.7933 56.8352 17.5805L41.9195 2.66486C41.7067 2.45305 41.4541 2.28531 41.1764 2.17122C40.8986 2.05714 40.6011 1.99896 40.3008 2.00001V2.00001Z",
    stroke: "#EA7000",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 45.9375C32.3845 45.9375 33.9375 44.3845 33.9375 42.4688C33.9375 40.553 32.3845 39 30.4688 39C28.553 39 27 40.553 27 42.4688C27 44.3845 28.553 45.9375 30.4688 45.9375Z",
    fill: "#EA7000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.088c562adfd6bb4a50fd1f8740e05013.svg";
export { ForwardRef as ReactComponent };